import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import AnythingService from "../AnythingService";
import Logger from "../../../services/Logger";
import { montrealYmdFromDate } from "../../../pages/components/montrealCalendar";

export default function WordOfDayBatchMain() {
    const [startDate, setStartDate] = useState(() => montrealYmdFromDate());
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const handleBatch = async () => {
        const d = String(startDate || "").trim();
        if (!d) {
            setError("Choose a start date (ISO format YYYY-MM-DD).");
            return;
        }
        setLoading(true);
        setError(null);
        setSuccess(null);
        try {
            const result = await AnythingService.batchWordOfTheDay(d);
            setSuccess(
                result != null
                    ? typeof result === "string"
                        ? result
                        : JSON.stringify(result, null, 2)
                    : "Batch completed."
            );
        } catch (err) {
            Logger.error("Word-of-day batch error:", err);
            setError(err.message || "Batch request failed.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%", maxWidth: 560 }}>
            <Typography variant="h5" sx={{ mb: 0 }}>
                Batch word of the day
            </Typography>
            <Typography variant="body2" color="text.secondary">
                Backfill <code>word_of_the_day</code> for published grid/cross templates with{" "}
                <code>published_at</code> on or after the start date (inclusive, start of day Montreal) that do not
                yet have a row. Calls{" "}
                <code>PUT /test/word-of-day/batch?startDate=…</code>.
            </Typography>
            <TextField
                label="Start date"
                type="date"
                value={startDate}
                onChange={(e) => {
                    setStartDate(e.target.value);
                    setError(null);
                    setSuccess(null);
                }}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
                disabled={loading}
                helperText={`YYYY-MM-DD (Montreal calendar). Today: ${montrealYmdFromDate()}`}
            />
            <Box>
                <Button variant="contained" onClick={handleBatch} disabled={loading}>
                    {loading ? "Running…" : "Batch"}
                </Button>
            </Box>
            {error ? <Alert severity="error">{error}</Alert> : null}
            {success ? (
                <Alert severity="success" sx={{ "& pre": { m: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" } }}>
                    {success.includes("\n") || success.startsWith("{") ? <pre>{success}</pre> : success}
                </Alert>
            ) : null}
        </Box>
    );
}
